import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import _ from 'lodash';

import { saveConfig, updateSelectedOptions } from '../../FilterActions';
import { CustomMultiselect } from '../common';

class LocalPercentiles extends Component {
  constructor(props) {
    super(props);
    this.state = {
      items: [],
      selectedItems: [],
    };

    this.handleChange = this.handleChange.bind(this);
  }

  componentDidMount() {
    this.updateState();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.items != this.props.items) {
      this.setState({
        items: this.props.items,
      });
    }

    if (prevProps.selectedItems != this.props.selectedItems) {
      this.setState({
        selectedItems: this.props.selectedItems,
      });
    }
  }

  updateState() {
    this.setState({
      items: this.props.items,
      selectedItems: this.props.selectedItems,
    });
  }

  handleChange(selected) {
    let ordered = _.orderBy(selected);
    this.props.updateSelectedOptions(ordered);
    this.props.saveConfig();
  }

  render() {
    const { items, selectedItems } = this.state;

    return (
      <CustomMultiselect
        name={'Percentiles'}
        items={items}
        selectedItems={selectedItems}
        onSelect={this.handleChange}
      />
    );
  }
}

LocalPercentiles.propTypes = {};

const mapDispatchToProps = (dispatch) => {
  return {
    saveConfig: () => dispatch(saveConfig()),
    updateSelectedOptions: (vals) => dispatch(updateSelectedOptions('percentiles', vals)),
  };
};

const mapStateToProps = (state) => {
  let chart = state.filters.chart;
  return {
    items: state.filters.allPercentiles,
    selectedItems: state.filters[chart].selectedPercentiles,
  };
};

const connected = connect(mapStateToProps, mapDispatchToProps)(LocalPercentiles);
export { connected as LocalPercentiles };
